// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallsForm__container-a42f86 {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.ScheduledCallsForm__content-c136a0 {
  flex: 1;
  padding: 24px;
  overflow: auto;
}

.ScheduledCallsForm__label-fe2593 {
  flex: 1;
  padding-top: 14px;
  margin-inline-end: 16px;
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}

.ScheduledCallsForm__dateTime-bbbb30 {
  display: flex;
  flex-direction: row;
}

.ScheduledCallsForm__date-e4e69f {
  width: 160px;
  margin-inline-end: 16px;
  cursor: pointer;
}

.ScheduledCallsForm__date-e4e69f * {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ScheduledCalls/components/ScheduledCallsForm/ScheduledCallsForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,OAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.content {\n  flex: 1;\n  padding: 24px;\n  overflow: auto;\n}\n\n.label {\n  flex: 1;\n  padding-top: 14px;\n  margin-inline-end: 16px;\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.dateTime {\n  display: flex;\n  flex-direction: row;\n}\n\n.date {\n  width: 160px;\n  margin-inline-end: 16px;\n  cursor: pointer;\n}\n\n.date * {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScheduledCallsForm__container-a42f86`,
	"content": `ScheduledCallsForm__content-c136a0`,
	"label": `ScheduledCallsForm__label-fe2593`,
	"dateTime": `ScheduledCallsForm__dateTime-bbbb30`,
	"date": `ScheduledCallsForm__date-e4e69f`
};
module.exports = ___CSS_LOADER_EXPORT___;
